function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    height: 500,
    width: 500,
    fill: "#000000",
    id: "svg871",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#fffeff",
      strokeWidth: 20.8372,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1394",
    cx: 251.72604,
    cy: 237.47536,
    r: 208.37289
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fffeff",
      strokeWidth: "21.0834px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 375.45068,65.298217 251.2421,447.57308 127.03332,65.298217 452.21588,301.55703 H 50.26833 Z",
    id: "path1635"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.667961,
      fill: "#9d32c1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "14.0025px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 174.48943,389.41995 -34.31557,10.12591 17.56865,-38.22272 -54.82414,-6.21876 44.44149,-25.31477 -63.5682,-25.31477 59.06779,-7.31317 -65.25584,-48.94187 54.00483,2.81277 -40.50363,-87.19533 48.37935,23.62712 0.12708,-85.50765 30.37772,47.25423 29.57322,-78.095626 20.2518,45.004026 30.37773,-64.693288 29.25261,65.818398 31.50283,-45.566587 18.33571,71.777977 30.47658,-38.75454 -2.81275,78.19449 50.43179,-26.13649 -46.49392,94.20508 56.92321,-13.66151 -54.673,55.29026 46.12913,4.50039 -48.94189,27.00243 38.25343,33.75301 -59.06781,1.12503 21.93946,32.62794 -35.06913,-6.1199 0.56259,49.50445 -40.02699,-22.22583 -12.40683,41.29463 -22.33496,-31.40394 -25.8159,32.62791 -12.93865,-44.44147 -45.0749,25.74328 z",
    id: "path4862"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.656311,
      fill: "#9d32c1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "14.0025px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 320.92194,389.41995 34.31557,10.12591 -17.56865,-38.22272 54.82414,-6.21876 -44.44148,-25.31477 63.5682,-25.31477 -59.0678,-7.31317 65.25585,-48.94187 -54.00484,2.81277 40.50361,-87.19533 -48.37934,23.62712 -0.12709,-85.50765 -30.3777,47.25423 -29.57323,-78.095626 -20.2518,45.004026 -30.37773,-64.693288 -29.25261,65.818398 -31.50283,-45.566587 -18.3357,71.777977 -30.47659,-38.75454 2.81275,78.19449 -50.43179,-26.13649 46.49394,94.20508 -56.92321,-13.66151 54.673,55.29026 -46.12913,4.50039 48.94188,27.00243 -38.25343,33.75301 59.06779,1.12503 -21.93945,32.62794 35.06913,-6.1199 -0.56259,49.50445 40.027,-22.22583 12.40683,41.29463 22.33496,-31.40394 25.8159,32.62791 12.93865,-44.44147 45.07489,25.74328 z",
    id: "path4432"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0ffd9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.41944,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 146.78608,304.70955 c 0.41137,-3.63485 11.89606,-20.06181 11.89606,-20.06181 0,0 -6.78101,-4.89569 -9.41993,-8.08214 -2.63888,-3.18639 -8.61532,-24.87892 -7.54856,-29.65503 0.91099,-4.07867 11.86201,-12.94038 11.86201,-12.94038 0,0 -2.14491,-21.19315 -0.22653,-30.35584 2.43781,-11.64354 7.20674,-20.32317 14.78446,-29.4934 9.70972,-11.75029 21.98186,-22.353 36.12522,-28.03748 14.41459,-5.79349 30.81984,-5.13716 46.35252,-4.85264 13.04466,0.23895 23.80019,0.33288 35.97039,5.03462 11.71526,4.52598 23.09147,11.54845 31.17297,21.16203 7.98648,9.50054 15.20453,22.33454 18.08917,34.40613 2.38291,9.972 1.39783,30.72652 1.39783,30.72652 0,0 10.0793,5.55708 11.50527,10.56465 1.87717,6.59205 -3.58321,28.78145 -6.51312,33.98479 -1.93164,3.43049 -7.96875,8.71747 -7.96875,8.71747 0,0 9.80506,16.03171 10.27073,19.55586 0.78702,5.95627 -7.70178,11.26703 -13.69266,11.72098 -3.70086,0.28047 -20.1455,-6.46333 -20.1455,-6.46333 l -10.24447,24.8024 -11.57998,-1.34901 -7.43453,-16.44663 -4.20682,3.38921 -4.47778,-8.18423 c 0,0 -19.37382,-4.09444 -27.19102,-3.72972 -8.22289,0.38367 -27.08073,5.25124 -27.08073,5.25124 l -3.58634,8.29122 -4.61723,-2.0044 -6.0096,11.76354 -12.1917,1.94037 -8.08773,-26.41994 c 0,0 -19.01587,7.21703 -22.2531,6.93904 -6.00589,-0.51572 -15.62844,-4.18433 -14.95055,-10.17409 z",
    id: "path1113"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0ffd9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.41944,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 178.46162,316.13429 7.0453,-2.67763 6.57054,20.90788 c 0,0 -2.84493,16.09427 -2.18704,24.35306 0.73235,9.19448 9.75451,25.89445 9.75451,25.89445 l 2.48769,-12.01909 11.07112,1.72801 3.66577,8.71248 4.13582,-1.3104 2.17121,6.35723 c 0,0 17.22104,8.7906 25.98475,8.64898 7.6627,-0.12318 23.05168,-8.57173 23.05168,-8.57173 l 3.78157,-5.77682 3.37497,1.59367 4.84875,-10.92575 9.74185,-1.80404 4.00689,14.33588 c 0,0 8.98105,-18.31684 10.27197,-27.06707 1.25603,-8.51339 0.399,-21.58524 0.399,-21.58524 l 9.02023,-19.1229 7.26682,3.09222 -7.31906,18.97093 c 0,0 0.15548,38.16475 -1.63642,44.72455 -2.02752,7.42264 -37.96874,44.51907 -44.01872,44.01872 -10.36857,-0.85748 -35.26412,-1.30214 -43.40309,-1.80404 -7.85416,-0.48432 -43.17151,-39.08302 -46.03006,-46.38774 -2.14902,-5.49159 0.59655,-43.49186 0.59655,-43.49186 z",
    id: "path2136"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#400040",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "15.0224px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 158.34974,250.65414 c 0.43417,-5.36284 5.6346,-9.37099 9.68469,-12.91291 8.63078,-7.54788 18.73794,-14.7573 30.02253,-16.7868 6.2162,-1.11796 13.88528,-1.15417 18.72372,2.90542 3.83212,3.21528 5.19325,9.21421 4.84234,14.20419 -0.63469,9.02509 -5.74164,17.94505 -12.26726,24.21172 -6.91161,6.63734 -16.63768,10.7757 -26.14865,11.94445 -4.67139,0.57401 -10.09621,0.21452 -13.88138,-2.58258 -6.34835,-4.6912 -11.61295,-13.11564 -10.97599,-20.98349 z",
    id: "path3262"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#400040",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "15.0224px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 342.17679,252.08629 c -0.34401,-5.30428 -4.60514,-9.82989 -8.39339,-13.55856 -7.87708,-7.7532 -15.95698,-13.60004 -26.61141,-16.54004 -6.97879,-1.92574 -15.57551,-3.83094 -21.71882,-6e-4 -4.14945,2.58718 -6.23743,8.28754 -6.45646,13.17256 -0.46389,10.34668 4.56847,20.99307 11.12337,29.01194 6.24512,7.63989 14.36518,12.1558 24.05336,14.02891 5.99556,1.15913 13.20462,0.41027 18.00922,-3.3588 6.95036,-5.45245 10.5659,-13.9401 9.99413,-22.75541 z",
    id: "path3668"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#400040",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "15.0224px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 235.74499,239.17336 c 1.48872,-3.45055 7.42492,-12.26727 7.42492,-12.26727 2.9724,3.69417 5.86995,7.42575 7.96528,11.55845 2.51007,-4.65289 5.02015,-7.87291 7.53022,-11.23563 0,0 5.04926,7.03907 6.77929,10.97598 2.60486,5.92772 6.50941,12.34055 5.27045,18.69571 -1.01867,5.22516 -9.78998,12.6181 -9.78998,12.6181 -2.42958,-4.75945 -5.1592,-9.39888 -9.78998,-13.27785 -4.08958,3.5295 -6.78504,8.45311 -9.57939,13.27785 0,0 -9.23242,-8.01467 -9.97274,-12.59008 -1.05398,-6.51382 2.27705,-13.3863 4.16193,-17.75526 z",
    id: "path3940"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.f5f15696309c3273dfe9e85f85d699f6.svg";
export { ForwardRef as ReactComponent };